import { Container, Header, Tabs } from '@amzn/awsui-components-react';

import React, { useState } from 'react';

import { JunoTMSIssues } from "../JunoTMSIssues/JunoTMSIssues";
import { JunoTMSIssuesArchive } from "../JunoTMSIssues/JunoTMSIssuesArchive";
import { ErrorBoundary } from 'react-error-boundary';
import { Fallback } from "../../../../Components/Fallback";

interface DashboardProps {
    domainIdentifier: string;
}

const CollectionInspector = (props: DashboardProps) => {
    const [loadGraphs] = useState<boolean>(false);

    const tabs = [
        {
            id: 'tmsIssues',
            name: 'TMS issues',
            label: 'TMS issues',
            content: !loadGraphs ? (
                <div style={{ margin: '-20px 0 -20px 0' }}>
                    <ErrorBoundary fallbackRender={props => <Fallback error={props.error} failedComponent={"TMSIssuesComponent"}/>}>
                        <JunoTMSIssues domainIdentifier={props.domainIdentifier}/>
                    </ErrorBoundary>
                </div>
            ) : (
                <div>Loading..</div>
            ),
            disabled: false,
        },
        {
            id: 'tmsIssuesArchive',
            name: 'TMS Archive issues',
            label: 'TMS Archive issues',
            content: !loadGraphs ? (
                <div style={{ margin: '-20px 0 -20px 0' }}>
                    <ErrorBoundary fallbackRender={props => <Fallback error={props.error} failedComponent={"ArchivedTMSIssuesComponent"}/>}>
                        <JunoTMSIssuesArchive domainIdentifier={props.domainIdentifier} />
                    </ErrorBoundary>
                </div>
            ) : (
                <div>Loading..</div>
            ),
            disabled: false,
        },
    ];
    return (
        <Container
            disableContentPaddings
            header={<Header variant="h2">Other information</Header>}
        >
            <Tabs tabs={tabs} />
        </Container>
    );
};

export { CollectionInspector };
